import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useNavigate } from 'react-router-dom'

import TextArea from "../../components/Inputs/TextArea/TextArea";
import Select from "../../components/Inputs/Select/Select";
import InputEmoji from "../../components/Inputs/InputEmoji/Emoji";
import Label from "../../components/Label/Label";
import WishListTitle from "../../components/WishListTitle";
import Footer from "../../components/FooterButton";
import Spinner from "../../components/Spinner";

import { customBrandOpts } from "../../utils/customBrandSettings";
import { storedEnv } from '../../utils/localStorage'
import MaisConteudoAPi from "../../services/MaisConteudoAPi";

import useUser from "../../hooks/UserContext";
import useWishList from "../../hooks/WishListContext";

import { Container, ErrorMessage, Form, InputLabelContainer } from './styles'
import { Input } from "../../components/Inputs/Input/InputStyle";


interface IFormValuesState {
    name: string;
    brand: string;
    description: string;
    link: string;
}
// interface ISelectedBrandState {
//     brandName: string;
// }
interface IErrorState {
    isToShow: boolean;
    error: string;
}

const CreateWishList: React.FC = () => {

    const inputEmojiRef = useRef<null | HTMLElement>(null)

    const { setOpenedWishList, onOpenWishListHandler } = useWishList()
    const { userBrandsMemo, userInfo } = useUser()
    const navigate = useNavigate()
    const customBrand = customBrandOpts.createWishList[storedEnv]

    const [formValues, setFormValues] = useState<IFormValuesState>({
        brand: '',
        description: '',
        name: '',
        link: '',
    })
    // const [selectedBrand, setSelectedBrand] = useState<ISelectedBrandState>({
    //     brandName: ''
    // })
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<IErrorState>({ error: '', isToShow: false })

    const selectedBrand = useMemo(() => {
        const realBrand = userBrandsMemo.find(brand => brand.filterItemValue === storedEnv)
        return {
            value: realBrand?.filterItemValue || '',
            label: realBrand?.filterItemName || ''
        }
    }, [userBrandsMemo])

    const onEmojiClickHandler = useCallback((event, emojiObject) => {
        setFormValues((prevState) => ({ ...prevState, 'name': `${prevState.name}${emojiObject.emoji}` }))
        inputEmojiRef.current?.focus()
    }, [])

    const onInputChangeHandler = useCallback((value: string, name: string) => (
        setFormValues((prevState) => ({ ...prevState, [name]: value }))
    ), [])

    // const onSelectChangeHandler = useCallback((value: string, name: string, label: string) => {
    //     let brandName = "brandName";
    //     setFormValues((prevState) => ({ ...prevState, [name]: value }));
    //     setSelectedBrand((prevState) => ({ ...prevState, [brandName]: label }));
    // }, [])

    useEffect(() => {
        setFormValues((prevState) => ({
            ...prevState,
            brand: selectedBrand.value,
            name: customBrand.nomeDaLojinha(userInfo.name) || prevState.name
        }))
        // eslint-disable-next-line
    }, [selectedBrand.value, userInfo.name]);

    const formIsValidMemo = useMemo(() => {
        let isValid = true

        isValid = formValues.name.trim().length > 0 && isValid
        isValid = formValues.brand.trim().length > 0 && isValid

        return isValid

    }, [formValues])

    const onClearFormInputsHandler = useCallback(() => {
        let newFormValues: IFormValuesState = formValues

        for (let key in formValues) {
            newFormValues = { ...newFormValues, [key]: '' }
        }

        return setFormValues(newFormValues)

    }, [formValues])

    const validateBrandMemo = useMemo(() => {
        let isValid = true
        isValid = formValues.brand === 'lojafarm'
        return isValid
    }, [formValues])


    const descriptionMemo = useMemo(() => (
        !validateBrandMemo ?
            formValues.description : ""
    ), [formValues, validateBrandMemo])


    const ParamsInsertMemo = useMemo(() => (
        formValues.link.length > 0 ?
            {
                code: userInfo.code,
                name: formValues.name,
                description: descriptionMemo,
                environment: formValues.brand,
                linkName: formValues.link
            }
            :
            {
                code: userInfo.code,
                name: formValues.name,
                description: descriptionMemo,
                environment: formValues.brand,
            }

    ), [descriptionMemo, formValues.brand, formValues.link, formValues.name, userInfo.code])


    const onSubmitFormHandler = useCallback(async () => {
        if (!formIsValidMemo) return

        try {
            setLoading(true)
            const res = await MaisConteudoAPi.post('/v1/wishlists', ParamsInsertMemo)

            onClearFormInputsHandler()
            setLoading(false)
            setOpenedWishList((prevState) => ({
                ...prevState,
                action: 'create',
                linkId: res.data.linkId,
                vtexBrandName: formValues.brand,
                name: formValues.name,
                description: formValues.description,
                linkName: formValues.link
            }))
            onOpenWishListHandler()
            navigate('/produtcs')

        } catch (error: any) {
            setLoading(false)
            setError({
                error: error.response?.data.message || "Algo de errado aconteceu, por favor tente novamente!",
                isToShow: true
            })
        }
    }, [formIsValidMemo, ParamsInsertMemo, onClearFormInputsHandler, setOpenedWishList, onOpenWishListHandler, navigate, formValues.brand, formValues.name, formValues.description, formValues.link])

    return (
        <Container>
            {
                loading
                    ? <Spinner />
                    :
                    (<Form>
                        <WishListTitle className="h1__createWishlist--text"> 1. Customize sua lojinha </WishListTitle>
                        <InputLabelContainer>
                            <Label htmlFor="name" name="Nome da lojinha" />
                            <InputEmoji
                                id="name"
                                name="name"
                                notAutoComplete
                                disabled={!!customBrand.nomeDaLojinha(userInfo.name)}
                                onChange={(event) => onInputChangeHandler(event.target.value, event.target.name)}
                                placeholder="Qual será o seu nome?"
                                onEmojiClickHandler={onEmojiClickHandler}
                                value={formValues.name}
                                refInput={inputEmojiRef as any}
                            />
                        </InputLabelContainer>

                        {customBrand.linkDaLojinha &&
                            <InputLabelContainer>
                                <Label htmlFor="link" name="Link da lojinha" />
                                <Label htmlFor="nome" border={true} className={error.isToShow ? "errorColor" : ""}>mais-lojinha.somalabs.com/
                                    <Input
                                        id="link"
                                        name="link"
                                        value={formValues.link}
                                        onChange={(event) => onInputChangeHandler(event.target.value.replace(/[\s]/g, ""), event.target.name)}
                                        maxLength={20}
                                        InputLink={true}
                                    />
                                </Label>
                                <ErrorMessage className="errorMessage" showError={error.isToShow}>Nome já utilizado. </ErrorMessage>
                            </InputLabelContainer>
                        }
                        {/* 
                        <InputLabelContainer>
                            <Label htmlFor="brand" name="Marca" />
                            <Select
                                placeholder="E a marca ?"
                                value={selectedBrand.brandName? {label: selectedBrand.brandName} : ""}
                                onChangeSelect={(value) => onSelectChangeHandler(value.value, 'brand', value.label)}
                                selectItems={userBrandsMemo.map((brand) => ({ value: brand.filterItemValue, label: brand.filterItemName }))}
                            />
                        </InputLabelContainer> */}

                        <InputLabelContainer>
                            <Label htmlFor="brand" name="Marca" />
                            {/* <Label htmlFor="brand" name={selectedBrand.label} /> */}
                            <Select
                                placeholder="E a marca ?"
                                disabled={true}
                                value={selectedBrand}
                            />
                        </InputLabelContainer>
                        {customBrand.descricao ?
                            <InputLabelContainer>
                                <Label htmlFor="description" name="Descrição" secondName="(opcional)" />
                                <TextArea
                                    id="name"
                                    name="description"
                                    onTextAreaChange={(event) => onInputChangeHandler(event.target.value, event.target.name)}
                                    placeholder={"Como você descreve esta lojinha?"}
                                    value={formValues.description}
                                />
                            </InputLabelContainer>
                            : null
                        }
                    </Form >)
            }
            <Footer onClick={onSubmitFormHandler} name="Escolher produtos" disabled={!formIsValidMemo} />
        </Container >
    )
}

export default CreateWishList;